import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Trash2, Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-green-600 rounded-full p-2">
                <Trash2 size={22} className="text-white" />
              </div>
              <div>
                <div className="text-white font-black text-lg leading-tight">LAWLOR</div>
                <div className="text-green-400 font-semibold text-xs tracking-widest uppercase">Rubbish Removal</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Fast, reliable, and affordable rubbish removal across Dublin, Meath, Louth and Kildare. No job too big or small.
            </p>
            <div className="flex gap-3">
              <a
                href="tel:0852730131"
                className="bg-green-600 hover:bg-green-500 text-white p-3 rounded-full transition-colors"
                aria-label="Call us"
              >
                <Phone size={18} />
              </a>
              <a
                href="https://wa.me/353852730131"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-500 text-white p-3 rounded-full transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle size={18} />
              </a>
              <a
                href="mailto:info@lawlorrubbish.ie"
                className="bg-green-600 hover:bg-green-500 text-white p-3 rounded-full transition-colors"
                aria-label="Email us"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-bold text-base mb-5 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/services', label: 'Our Services' },
                { to: '/gallery', label: 'Gallery' },
                { to: '/contact', label: 'Contact Us' },
              ].map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-green-400 transition-colors text-sm flex items-center gap-2"
                  >
                    <span className="text-green-500">›</span>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-base mb-5 uppercase tracking-wider">Services</h3>
            <ul className="space-y-3">
              {[
                'Rubbish Removal',
                'Property Clearance',
                'Furniture Removal',
                'Appliance Removal',
                'Estate Clean Out',
                'Hoarder Clear Out',
                'Commercial Rubbish',
                'Light Demolition',
              ].map((service) => (
                <li key={service} className="text-gray-400 text-sm flex items-center gap-2">
                  <span className="text-green-500">✓</span>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold text-base mb-5 uppercase tracking-wider">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-green-400 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-white font-semibold">085 273 0131</div>
                  <div className="text-gray-400 text-xs">+353 85 273 0131</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-green-400 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-white font-semibold">Areas Served</div>
                  <div className="text-gray-400 text-xs">Dublin, Meath, Louth & Kildare</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-green-400 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-white font-semibold">Mon – Sun</div>
                  <div className="text-gray-400 text-xs">7:00 AM – 8:00 PM</div>
                  <div className="text-green-400 text-xs font-semibold mt-1">Same Day Service Available</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm text-center sm:text-left">
            © {currentYear} Lawlor Rubbish Removal. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Locally Owned & Operated | Fast · Reliable · Affordable
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
